const YOUTUBE_PATTERN =
  /(?:youtube(?:-nocookie)?\.com\/(?:watch\?(?:[^#]*&)?v=|embed\/|shorts\/|live\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/i;

const VIMEO_PATTERN =
  /vimeo\.com\/(?:video\/|channels\/[^/]+\/|groups\/[^/]+\/videos\/)?(\d+)/i;

const LOOM_PATTERN = /loom\.com\/(?:share|embed)\/([A-Za-z0-9]+)/i;

const YOUTUBE_EMBED_HOST = 'www.youtube.com';
const VIMEO_EMBED_HOST = 'player.vimeo.com';
const LOOM_EMBED_HOST = 'www.loom.com';

const VIDEO_EMBED_HOSTS: ReadonlySet<string> = new Set([
  YOUTUBE_EMBED_HOST,
  VIMEO_EMBED_HOST,
  LOOM_EMBED_HOST,
]);

const SECURE_PROTOCOL = 'https:';

export function isVideoEmbedProviderUrl(url: string): boolean {
  try {
    const { protocol, hostname } = new URL(url);
    return protocol === SECURE_PROTOCOL && VIDEO_EMBED_HOSTS.has(hostname);
  } catch {
    return false;
  }
}

export function getVideoPosterUrl(url: string): string | null {
  if (!url) {
    return null;
  }

  const youTube = YOUTUBE_PATTERN.exec(url);

  return youTube
    ? `https://img.youtube.com/vi/${youTube[1]}/hqdefault.jpg`
    : null;
}

export interface VideoEmbedOptions {
  readonly autoplay?: boolean;
}

function withAutoplay(embedUrl: string, autoplay: boolean | undefined): string {
  return autoplay ? `${embedUrl}?autoplay=1` : embedUrl;
}

export function getVideoEmbedUrl(
  url: string,
  options: VideoEmbedOptions = {}
): string | null {
  if (!url) {
    return null;
  }

  const youTube = YOUTUBE_PATTERN.exec(url);
  if (youTube) {
    return withAutoplay(
      `https://${YOUTUBE_EMBED_HOST}/embed/${youTube[1]}`,
      options.autoplay
    );
  }

  const vimeo = VIMEO_PATTERN.exec(url);
  if (vimeo) {
    return withAutoplay(
      `https://${VIMEO_EMBED_HOST}/video/${vimeo[1]}`,
      options.autoplay
    );
  }

  const loom = LOOM_PATTERN.exec(url);
  if (loom) {
    return withAutoplay(
      `https://${LOOM_EMBED_HOST}/embed/${loom[1]}`,
      options.autoplay
    );
  }

  return null;
}
